import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './core/components/not-found/not-found.component';

const routes: Routes = [
  {
    path: 'landings',
    title: 'appLandings',
    loadChildren: () => import('app/landings/landings.module').then((m) => m.LandingsModule)
  },
  {
    path: 'enrollment',
    title: 'appEnrollment',
    loadChildren: () => import('app/enrollment/enrollment.module').then((m) => m.EnrollmentModule)
  },
  {
    path: 'register',
    title: 'appRegister',
    loadChildren: () => import('app/register/register.module').then((m) => m.RegisterModule)
  },
  {
    path: 'accounts',
    title: 'appAccounts',
    loadChildren: () => import('app/plans-store/plans-store.module').then((m) => m.PlansStoreModule)
  },
  {
    path: 'techTest',
    title: 'appTechTest',
    loadChildren: () => import('app/tech-test/tech-test.module').then((m) => m.TechTestModule)
  },
  {
    path: 'email-preferences',
    title: 'appEmailPreferences',
    loadChildren: () =>
      import('app/email-preferences/email-preferences.module').then((m) => m.EmailPreferencesModule)
  },
  { path: '', title: 'app', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', title: 'appAny', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
